import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { maxBy } from 'lodash';
import { CBadge, CListGroupItem } from '@coreui/react';
import moment from 'moment';
import { ChatData } from '../../../shared/models/chat';
import { CONTACT_INFO_FIELDS } from '../../../shared/constants/chat.constants';
import { ConfigContext } from '../../../shared/contexts/journeyConfig.context';

interface ContactProps {
  chat: ChatData;
  activeChatId: string;
  onSelectChat: (chat: string) => void;
}

const Contact = (props: ContactProps) => {
  const {
    chat,
    activeChatId,
    onSelectChat
  } = props;
  const elRef = useRef(null);
  const labels = useContext(ConfigContext);
  const unreadMessagesCount = chat?.unreadMessagesCount;
  const lastCreatedTime = useMemo(() => {
    if (chat?.messages?.length > 0) {
      const maxCreatedTime = maxBy(chat?.messages, 'created_time')?.created_time ?? 0;
      if (maxCreatedTime) {
        const date = moment(maxCreatedTime);
        const timeFormat = date.isBefore(moment().startOf('day')) ? 'M/D/YY' : 'hh:mm A';
        return date.format(timeFormat);
      }
    }
    return null;
  }, [chat?.messages]);

  useEffect(() => {
    if (chat?.chat_id === activeChatId && elRef?.current) {
      setTimeout(() => {
        elRef?.current?.scrollIntoView({behavior: "smooth", block: "start"});
      });
    }
  }, [chat?.chat_id, activeChatId, elRef?.current]);

  return (
    <CListGroupItem
      innerRef={elRef}
      className={`chat-list-item ${activeChatId === chat?.chat_id && 'active-chat'}`}
      onClick={() => onSelectChat(chat?.chat_id)}
    >
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <div className="font-weight-bold"
            /* eslint-disable-next-line react/no-danger */
               dangerouslySetInnerHTML={{
                 __html: chat?.chatInfo?.customer
               }}
          />
          <div>{lastCreatedTime}</div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            {
              CONTACT_INFO_FIELDS(labels).map((field) => (
                <div key={field.key}
                  /* eslint-disable-next-line react/no-danger */
                     dangerouslySetInnerHTML={{
                       __html: `<span class="font-weight-bold">${field.title}:</span> ${chat?.chatInfo?.[field.key]}`
                     }}
                />
              ))
            }
          </div>
          {unreadMessagesCount ? <CBadge color="danger">{unreadMessagesCount}</CBadge> : null}
        </div>
      </div>
    </CListGroupItem>
  );
};

export default Contact;
